// extracted by mini-css-extract-plugin
module.exports = {"arrow-container":"styles__arrow-container___2bEl0","arrow":"styles__arrow___1cbyg","icon":"styles__icon___r02O1"};